import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {isPlatformBrowser, Location} from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class PreviousRouteService {

    private routes: string[] = [];

    constructor(@Inject(PLATFORM_ID) public platformId: any,
                private router: Router,
                private location: Location) {
        if (isPlatformBrowser(this.platformId)) {
            this.routes.push(this.location.path());

            this.router.events.pipe(filter((event: any): boolean => event instanceof NavigationEnd)).subscribe((event: NavigationEnd): void => {
                let routerUrl: string = (event.url) ? event.url : this.router.url;
                this.routes.push(routerUrl);
            });
        }
    }

    public getPrevious(): string {
        return this.routes.length > 0 ? this.routes[this.routes.length - 1] : undefined;
    }
}